import { Button, Grid, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { TextField } from '../../components/form/react-hook-form-components';
import useFormStyles from '../../styles/useFormStyles';
import HelpIcon from '@mui/icons-material/Help';
import { AutoScrollSettings } from './AutoScrollOptionsPopup';

interface IAutoScrollOptionsFormInputs {
  scrollDelay: number;
  scrollIncrement: number;
}

interface AutoScrollOptionsFormProps {
  currentSettings: AutoScrollSettings;
  onSubmitHandler: (input: IAutoScrollOptionsFormInputs) => void;
  onCancelHandler: () => void;
}

const AutoScrollOptionsForm = (props: AutoScrollOptionsFormProps) => {
  const { currentSettings, onSubmitHandler, onCancelHandler } = props;
  const methods = useForm<IAutoScrollOptionsFormInputs>({
    defaultValues: {
      scrollDelay: currentSettings.scrollDelay,
      scrollIncrement: currentSettings.scrollIncrement,
    },
  });
  const { handleSubmit } = methods;
  const classes = useFormStyles();

  return (
    <FormProvider {...methods}>
      <form id="form" onSubmit={handleSubmit(onSubmitHandler)}>
        <Grid container spacing={1.5} width={'16rem'}>
          <Grid item xs={12}>
            <Stack spacing={1} direction="row" alignItems={'center'}>
              <TextField name="scrollDelay" label="Scroll Delay (Seconds)" numericInput min={3} max={10} required />
              <Tooltip title="The amount of seconds before the next scroll takes place (Default = 5 seconds).">
                <HelpIcon />
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={1} direction="row" alignItems={'center'}>
              <TextField name="scrollIncrement" label="Scroll Increment (Pixels)" numericInput required min={1} />
              <Tooltip title="The amount of pixels to move down by on each scroll (Default = 150 pixels)">
                <HelpIcon />
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item container direction="row" justifyContent={'end'} spacing={1} marginTop={1}>
            <Grid item>
              <Button variant="contained" size="large" className={classes.submitButton} type="submit">
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="large" color="neutral" onClick={onCancelHandler}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default AutoScrollOptionsForm;
